export default __webpack_public_path__ + "static/media/photo 2.b28f43c8.jpg";